/* eslint-disable no-alert, no-console */ /* eslint-disable no-duplicate-imports */
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '../../client'
import type { RequestConfig, ResponseErrorConfig } from '../../client'
import type {
  PostApiEmploymentsBulkUpdateLeaveDaysMutationRequest,
  PostApiEmploymentsBulkUpdateLeaveDaysMutationResponse,
} from '../models/PostApiEmploymentsBulkUpdateLeaveDays'

function getPostApiEmploymentsBulkUpdateLeaveDaysUrl() {
  return `/api/employments/bulk_update_leave_days.json` as const
}

/**
 * @description Bulk-update ferie/feriefri/seniordage på eksisterende beskæftigelser
 * @summary Bulk update leave days
 * {@link /api/employments/bulk_update_leave_days.json}
 */
export async function postApiEmploymentsBulkUpdateLeaveDays(
  data?: PostApiEmploymentsBulkUpdateLeaveDaysMutationRequest,
  config: Partial<RequestConfig<PostApiEmploymentsBulkUpdateLeaveDaysMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    PostApiEmploymentsBulkUpdateLeaveDaysMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiEmploymentsBulkUpdateLeaveDaysMutationRequest
  >({ method: 'POST', url: getPostApiEmploymentsBulkUpdateLeaveDaysUrl().toString(), data, ...requestConfig })
  return res.data
}